<div class="flex items-center select-none" role="status" aria-label="Loading">
    <div class="flex" [ngClass]="gapClass">
        @for (dotIndex of dots; track dotIndex) {
            <div
                class="rounded-full transition-colors duration-300"
                [ngClass]="[
                    sizeClass,
                    isActive(dotIndex) ? darkClass : lightClass,
                ]"
            ></div>
        }
    </div>
</div>
